"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSCUpdateInfoToJSON = exports.SSCUpdateInfoFromJSONTyped = exports.SSCUpdateInfoFromJSON = exports.instanceOfSSCUpdateInfo = void 0;
var runtime_1 = require("../runtime");
var RebootScheduleInfo_1 = require("./RebootScheduleInfo");
var UpgradeItem_1 = require("./UpgradeItem");
var UpgradeState_1 = require("./UpgradeState");
/**
 * Check if a given object implements the SSCUpdateInfo interface.
 */
function instanceOfSSCUpdateInfo(value) {
    var isInstance = true;
    isInstance = isInstance && "serialNumber" in value;
    return isInstance;
}
exports.instanceOfSSCUpdateInfo = instanceOfSSCUpdateInfo;
function SSCUpdateInfoFromJSON(json) {
    return SSCUpdateInfoFromJSONTyped(json, false);
}
exports.SSCUpdateInfoFromJSON = SSCUpdateInfoFromJSON;
function SSCUpdateInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'serialNumber': json['serial_number'],
        'customerId': !(0, runtime_1.exists)(json, 'customer_id') ? undefined : json['customer_id'],
        'deploymentId': !(0, runtime_1.exists)(json, 'deployment_id') ? undefined : json['deployment_id'],
        'stagedNetworking': !(0, runtime_1.exists)(json, 'staged_networking') ? undefined : json['staged_networking'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, UpgradeState_1.UpgradeStateFromJSON)(json['status']),
        'rebootSchedule': !(0, runtime_1.exists)(json, 'reboot_schedule') ? undefined : (0, RebootScheduleInfo_1.RebootScheduleInfoFromJSON)(json['reboot_schedule']),
        'platform': !(0, runtime_1.exists)(json, 'platform') ? undefined : json['platform'],
        'model': !(0, runtime_1.exists)(json, 'model') ? undefined : json['model'],
        'upgradeHistory': !(0, runtime_1.exists)(json, 'upgrade_history') ? undefined : (json['upgrade_history'].map(UpgradeItem_1.UpgradeItemFromJSON)),
    };
}
exports.SSCUpdateInfoFromJSONTyped = SSCUpdateInfoFromJSONTyped;
function SSCUpdateInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'serial_number': value.serialNumber,
        'customer_id': value.customerId,
        'deployment_id': value.deploymentId,
        'staged_networking': value.stagedNetworking,
        'status': (0, UpgradeState_1.UpgradeStateToJSON)(value.status),
        'reboot_schedule': (0, RebootScheduleInfo_1.RebootScheduleInfoToJSON)(value.rebootSchedule),
        'platform': value.platform,
        'model': value.model,
        'upgrade_history': value.upgradeHistory === undefined ? undefined : (value.upgradeHistory.map(UpgradeItem_1.UpgradeItemToJSON)),
    };
}
exports.SSCUpdateInfoToJSON = SSCUpdateInfoToJSON;
